module.exports = __webpack_public_path__ + "img/_weapon_potion_06.9e26ce11.png";